import { makeArray } from '@ember/array';
import { computed, get } from '@ember/object';

export default function containsComputed(array, attr) {
  return computed(`${array}.[]`, function () {
    return makeArray(get(this, array)).includes(attr);
  });
}
